import { computerScreens } from "~src/helpers/computerScreens.js";
import { preloadImages } from "../helpers/preloadImages";
import * as tip2DImageFiles from "../tips/2DImageView/images/*.jpg";
import { StartScreenImages } from "../fullscreenModals/startingScreen.js";
import { mobileOrNot } from "~/src/helpers/mobileDetect.js";
import { lockConsoleImages } from "../puzzles/lockconsole";
import { pickText } from "../textcontents";


//export let flatExtras = window.pakopeliPublicAssetUrl + "assets/heinakuu/lossy-compressed/huone1_ekstrat.gltf";
//export let warehouseExtras = window.pakopeliPublicAssetUrl + "assets/heinakuu/lossy-compressed/huone3_ekstrat.gltf";
//export let bunkerExtras = window.pakopeliPublicAssetUrl + "assets/heinakuu/lossy-compressed/huone3_ekstrat.gltf";

let imagesReady = false;
const allLoadingReady = () => {
  document.getElementById("percent-rooms").remove();
  const selector = document.getElementById("all-loaded");
  let startingGameText = pickText("loading", "3")
  selector.innerHTML = startingGameText;
};

export const assetContainers = {
  allReady: () =>
    imagesReady &&
    assetContainers.flat.ready &&
    assetContainers.warehouse.ready &&
    assetContainers.bunker.ready,
  flat: {
    container: null,
    ready: false,
    addToScene: (scene) => {
      if (scene.getMeshByName("H1__Yhdistetyt")) return;
      const container = assetContainers.flat.container;
      container.addAllToScene();
      computerScreens.init(scene);

      const hide = (name) => {
        const el = container.meshes.find((e) => e.name === name);
        if (el) {
          el.setEnabled(false);
        }
      };

      // hide("H1_Valiovi");
      hide("H1_lukkokonsoli_Auki");
      //hide("H1_Varaston_ovi");
      // hide("H1_Ulko_ovi");
      hide("H1_Matrixjuliste_Valmis");

      computerScreens.flat.close();
      computerScreens.warehouse.close();
      computerScreens.bunker.close();
      assetContainers.flat.ready = true;

      if (assetContainers.allReady()) {
        console.log("all ready");
      }
    },
  },
  warehouse: {
    container: null,
    ready: false,
    addToScene: () => {
      const container = assetContainers.warehouse.container;
      container.addAllToScene();

      assetContainers.warehouse2.addToScene();


    },
  },
  warehouse2: {
    container: null,
    ready: false,
    addToScene: () => {
      //if(scene.getMeshByName("H2__Yhdistetyt")) return;
      const container = assetContainers.warehouse2.container;
      container.addAllToScene();
      const laatikkoCollision = container.meshes.map((e) => {
        e.visibility = 0;
        e.checkCollisions = true;
        e.position.y = 1.183;
      });
    },
  },
  bunker: {
    container: null,
    ready: false,
    addToScene: () => {
      if (scene.getMeshByName("H3__Yhdistetyt")) return;
      const container = assetContainers.bunker.container;
      container.addAllToScene();
      const betoni = container.meshes.find(
        (e) => e.name === "H3_Betoniporsaat_Mesh"
      );
      if (betoni) betoni.visibility = 0;
      scene.getMeshByName("Huone3_Portaat").dispose() 
    },
  },
};

window.ac = assetContainers;

const sceneLoaderTemplate = ({ type, room, file, onSuccess, scene }) => {
  function progress(evt) {
    // onProgress function to display loading percent rate
    let loadedPercent = 0;
    if (evt.lengthComputable) {
      loadedPercent = ((evt.loaded * 100) / evt.total).toFixed();
    } else {
      var dlCount = evt.loaded / (1024 * 1024);
      loadedPercent = Math.floor(dlCount * 100.0) / 100.0;
    }

    let textContainer = document.getElementById("loadingScreenPercentFlat");
    let selector;
    if (room === "flat")
      selector = document.getElementById("loadingScreenPercentFlat");
    if (room === "warehouse")
      selector = document.getElementById("loadingScreenPercentWarehouse");
    if (room === "bunker")
      selector = document.getElementById("loadingScreenPercentBunker");

    if (!selector) return;

    // assuming "loadingScreenPercent" is an existing html element
    selector.innerHTML =
      loadedPercent < 100
        ? `${pickText("loading", "1")} ${room} ${loadedPercent} %`
        : pickText("loading", "2");
        

    if (loadedPercent == 100) {
      assetContainers[room].ready = true;
      if (assetContainers.allReady()) {
        allLoadingReady();
      }
    }
  }

  if (type === "LoadAssetContainer") {
    BABYLON.SceneLoader.LoadAssetContainer(
      "",
      file,
      scene,
      (container) => {
        if (type === "LoadAssetContainer") {
          assetContainers[room].container = container;
          if (onSuccess) {
            onSuccess();
          }
          return;
        }
      },
      progress
    );
  } else if (type === "ImportMesh") {
    BABYLON.SceneLoader["ImportMesh"]("", "", file, scene, onSuccess, progress);
  }
};

const assetsManager = (() => {
  let assetsManager;
  let sceneInitialized; // returns scene


console.log(window.pakopeliPublicAssetUrl)

let warehouseFile = () => mobileOrNot() ? window.pakopeliPublicAssetUrl + "assets/latest/warehouse_reduced_50.glb" : window.pakopeliPublicAssetUrl + "assets/latest/warehouse.glb"
let warehouseCollisionsFile = () => window.pakopeliPublicAssetUrl + "assets/latest/trigger.glb";
let flatFile = () => mobileOrNot() ? window.pakopeliPublicAssetUrl + "assets/latest/flat_reduced_50_screentext_changed.glb" : window.pakopeliPublicAssetUrl + "assets/latest/flat.glb";
let bunkerFile =() => mobileOrNot() ? window.pakopeliPublicAssetUrl + "assets/latest/bunker_reduced_50.glb" : window.pakopeliPublicAssetUrl + "assets/latest/bunker.glb";
let phones = () => window.pakopeliPublicAssetUrl + "assets/latest/phones.glb";
let phoneGlows = () =>  window.pakopeliPublicAssetUrl + "assets/latest/phone_glows.glb";

  const store = (BABYLON, scene) => {
    sceneInitialized = scene;
    assetsManager = new BABYLON.AssetsManager(scene);
    assetsManager.onProgress = function (
      remainingCount,
      totalCount,
      lastFinishedTask
    ) {
      const message = "Ladataan... ";
      document.getElementById("loading-message").innerHTML = message;
    };

    assetsManager.onTasksDoneObservable.add(function (tasks) {
      var errors = tasks.filter(function (task) {
        return task.taskState === BABYLON.AssetTaskState.ERROR;
      });
      var successes = tasks.filter(function (task) {
        return task.taskState !== BABYLON.AssetTaskState.ERROR;
      });
      if (errors.length > 0) {
        console.log(errors);
        console.log("error loading assets");
      }
    });
  };

  const update = (props) => {
    if (props && props.loadingScreen !== false) {
      assetsManager.useDefaultLoadingScreen = true;
    } else {
      assetsManager.useDefaultLoadingScreen = false;
    }

    if (props && props.async) {
      return assetsManager.loadAsync();
    } else {
      assetsManager.load();
    }
  };

  return {
    init: (BABYLON, scene) => store(BABYLON, scene),
    loadLevelCollision: (scene) => {
      var meshLevel_c = assetsManager.addMeshTask(
        "level_collision",
        "",
        window.pakopeliPublicAssetUrl + "assets/level_v0.51_collision.babylon"
      );

      sceneLoaderTemplate({
        type: "ImportMesh",
        onSuccess: function (meshes) {
          var mesh = meshes[1];
          console.log("collision");
          mesh.position = BABYLON.Vector3.Zero();
        },
        file: window.pakopeliPublicAssetUrl + "assets/level_v0.51_collision.babylon",
        room: "collision",
        scene,
      });
      meshLevel_c;
    },
    loadFlatObjects: () => {
      return null;
    },
    loadFlat: (scene) => {
      //TYPE: ImportMesh
      sceneLoaderTemplate({
        type: "LoadAssetContainer",
        file: flatFile(),
        room: "flat",
        scene,
      });

      sceneLoaderTemplate({
        type: "ImportMesh",
        file: phoneGlows(),
        onSuccess: () => {},
        room: "flat",
        scene,
      });

/*       sceneLoaderTemplate({
        type: "ImportMesh",
        file: phones,
        onSuccess: () => {
          const data = {
            position: {
              x: -132.98276966914582,
              y: -25.825653037086585,
              z: -178.7392003356422,
            },
            rotation: {
              x: 0.6648275263484252,
              y: 0.24466886044401806,
              z: -0.2257947969265679,
              w: 0.668698904718509,
            },
            scaling: {
              x: 1.001777107052715,
              y: 1.0082404848802342,
              z: 1.0222680977158305,
            },
          };
          const phone3 = scene.getMeshByName("Huone3_puhelin.001");
          phone3.rotationQuaternion.x = data.rotation.x;
          phone3.rotationQuaternion.y = data.rotation.y;
          phone3.rotationQuaternion.z = data.rotation.z;
          phone3.rotationQuaternion.w = data.rotation.w;

          phone3.position.x = data.position.x;
          phone3.position.y = data.position.y;
          phone3.position.z = data.position.z;

          phone3.scaling.x = data.scaling.x;
          phone3.scaling.y = data.scaling.y;
          phone3.scaling.z = data.scaling.z;
        },
        room: "flat",
        scene,
      }); */
    },
    loadWarehouse: (scene) => {
      sceneLoaderTemplate({
        type: "LoadAssetContainer",
        file: warehouseFile(),
        room: "warehouse",
        onSuccess: () => {
      

        },
        scene,
      });

      sceneLoaderTemplate({
        type: "LoadAssetContainer",
        file: warehouseCollisionsFile(),
        room: "warehouse2",
        scene,
      });

      
    },
    loadBunker: (scene) => {
      sceneLoaderTemplate({
        type: "LoadAssetContainer",
        file: bunkerFile(),
        room: "bunker",
        onSuccess: () => {},
        scene,
      });
      sceneLoaderTemplate({
        type: "ImportMesh",
        onSuccess: function (meshes) {
          console.log(meshes)
         meshes[1].checkCollisions = true;
         scene.getMeshByName("Huone3_Portaat.001").visibility = 0;

        },
        file: window.pakopeliPublicAssetUrl + "assets/latest/huone3_news_stairs.glb",
        room: "h3_uudet_portaat",
        scene,
      });;
    },
    loadImages: async () => {
      let urls = Object.values(tip2DImageFiles).filter(
        (e) => typeof e === "string"
      );
      urls = [...urls, ...StartScreenImages, ...lockConsoleImages];
      await new Promise((resolve, reject) => {
        const selector = document.getElementById("loadingScreenPercentImages");
        preloadImages({
          urls: urls,
          progressCallback: (loadedCounter, total) => {
            if (selector)
              selector.innerHTML = `${pickText("loading", "5")}: ${Math.round(
                (loadedCounter / total) * 100
              )} %`;
          },
          allImagesLoadedCallback: function () {
            imagesReady = true;

            if (selector) selector.innerHTML = pickText("loading", "4");
            resolve();
          },
        });
      });
      return;
    },
    update: ({ loadingScreen, async }) => update({ loadingScreen, async }),
  };
})();

export { assetsManager };
